import { PlanningService } from "@3gaam/api/services";
import {
  ChangeChapterStateInput,
  ChangeChapterStateOutput,
  ChangeProgressTypeInput,
  ChangeProgressTypeOutput,
  ChapterSpeedConfigurationOutput,
  ChaptersPlannedTimeSumReportsOutput,
  ChaptersQueryOutput,
  ConfigMaxRoundInput,
  ConfigSpeedsInput,
  ConfigureChapterSpeedInput,
  ConfigureChapterSpeedOutput,
  EnrollmentWithExamWithFieldWithBranchPortable,
  FixizeEnrollmentStudyPeriodsStartTypeInput,
  FixizeEnrollmentStudyPeriodsStartTypeOutput,
  GenerateTimetableInput,
  GenerateTimetableOutput,
  LoadApplicantProfileOutput,
  MicroscopicPlannedResourcesOutput,
  OrderizeEnrollmentStudyPeriodsStartTypeInput,
  OrderizeEnrollmentStudyPeriodsStartTypeOutput,
  PeriodicElementReportsOutput,
  PersistTimetableItemInput,
  PersistTimetableItemOutput,
  PlanChapterOutput,
  PlanChaptersInput,
  PlanChaptersOutput,
  PlannedChapterQueryOutput,
  PlannedChapterStates,
  PlannedElementPortable,
  PlannedResourceDetailsOutput,
  PlannedResourcePlusResourceRequestPortable,
  PlannedResourcesQueryOutput,
  PlannedResourceWithResourcePortable,
  PlannedResourceWithResourceWithFocusedChaptersPortable,
  PlanResourceInput,
  PlanResourceOutput,
  PlanResourcesInput,
  PlanResourcesOutput,
  PostponeChapterInput,
  PostponeChapterOutput,
  RegenerateStudyScheduleInput,
  RegenerateStudyScheduleOutput,
  RemoveAllTimetableItemsOutput,
  RemoveTimetableItemOutput,
  ReportableElementsOutput,
  ReportProgressesInput,
  ReportProgressesOutput,
  ResetEnrollmentInput,
  ResetEnrollmentOutput,
  ResourcePackagePortable,
  ResourcePackageResourcesOutput,
  ResourceQueryOutput,
  ResourcesProgressReportsOutput,
  ScheduledChapterReviewsOutput,
  ScheduledChapterReviewWithPlannedChapterPortable,
  StudyAnalyseOutput,
  StudyPeriodStartTypes,
  StudyScheduleOutput,
  TimetableItemPortable,
  TimetableItemsQueryOutput,
  TimetableItemWithColorWithResourcePortable,
  UnplanChapterOutput,
  UnplanResourceInput,
  UnplanResourceOutput,
  UpdateApplicantProfileOutput,
  UpdateEnrollmentOutput,
  UpdatePlannedResourceInput,
  UpdatePlannedResourceOutput,
  PlannedChapterWithChapterWithFocusedPortable,
  ChapterPortable,
  InternalExternalResourcePortable,
} from "@3gaam/api/types/planning";
import { ChaptersQueryInput, PlannedChapterQueryInput, PlannedResourcesQueryInput, ResourceQueryInput, TimetableItemsQueryInput } from "@3gaam/api/types/planningMapped";
import { paginationThunk, infiniteScrollThunk } from "@3gaam/shared/hooks/useQuery";
import {
  createAsyncThunk,
  createSlice,
  isAsyncThunkAction,
  isFulfilled,
  isPending,
  isRejected,
  PayloadAction,
} from "@reduxjs/toolkit";

export const generateTimetableAction = createAsyncThunk(
  "planning/generateTimetable",
  async (payload: GenerateTimetableInput, thunkAPI) => {
    const res = await PlanningService.generateTimetable(payload);
    return res.data;
  },
);

export const persistTimetableItemAction = createAsyncThunk(
  "planning/persistTimetableItem",
  async (payload: PersistTimetableItemInput, thunkAPI) => {
    const res = await PlanningService.persistTimetableItem(payload);
    return res.data;
  },
);

export const fixizeEnrollmentStudyPeriodsStartTypeAction = createAsyncThunk(
  "planning/fixizeEnrollmentStudyPeriodsStartType",
  async (payload: FixizeEnrollmentStudyPeriodsStartTypeInput, thunkAPI) => {
    const res = await PlanningService.fixizeEnrollmentStudyPeriodsStartType(
      payload,
    );
    return res.data;
  },
);

export const orderizeEnrollmentStudyPeriodsStartTypeAction = createAsyncThunk(
  "planning/orderizeEnrollmentStudyPeriodsStartType",
  async (payload: OrderizeEnrollmentStudyPeriodsStartTypeInput, thunkAPI) => {
    const res = await PlanningService.orderizeEnrollmentStudyPeriodsStartType(
      payload,
    );
    return res.data;
  },
);

export const removeAllBasicStudyPeriodsAction = createAsyncThunk(
  "planning/removeAllBasicStudyPeriods",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.removeAllBasicStudyPeriods(payload);
    return res.data;
  },
);

export const resetEnrollmentAction = createAsyncThunk(
  "planning/resetEnrollment",
  async (payload: ResetEnrollmentInput, thunkAPI) => {
    const res = await PlanningService.resetEnrollment(payload);
    return res.data;
  },
);

export const timeTableItemsAction = createAsyncThunk<TimetableItemsQueryOutput, TimetableItemsQueryInput>(
  "planning/timetableItems",
  async (payload, thunkAPI) => {

    const res = await infiniteScrollThunk<TimetableItemsQueryInput, TimetableItemWithColorWithResourcePortable, TimetableItemsQueryOutput>(
      PlanningService.timetableItems, payload);
    return res.data;
  },
);

export const enrollmentDetailsAction = createAsyncThunk(
  "planning/enrollmentDetails",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.enrollmentDetails(payload);
    return res.data;
  },
);

export const reportProgressAction = createAsyncThunk(
  "planning/reportProgresses",
  async (payload: ReportProgressesInput, thunkAPI) => {
    const res = await PlanningService.reportProgresses(payload);
    return res.data;
  },
);

export const reportProgressesAction = createAsyncThunk(
  "planning/reportProgresses",
  async (payload: ReportProgressesInput, thunkAPI) => {
    const res = await PlanningService.reportProgresses(payload);
    return res.data;
  },
);

export const configSpeedsAction = createAsyncThunk(
  "planning/configSpeeds",
  async (payload: ConfigSpeedsInput, thunkAPI) => {
    const res = await PlanningService.configSpeeds(payload);
    return res.data;
  },
);

export const configSpeedAction = createAsyncThunk(
  "planning/configChapterSpeed",
  async (payload: ConfigureChapterSpeedInput, thunkAPI) => {
    const res = await PlanningService.configureChapterSpeed(payload);
    return res.data;
  },
);

export const regenerateStudyScheduleAction = createAsyncThunk(
  "planning/regenerateStudySchedule",
  async (payload: RegenerateStudyScheduleInput, thunkAPI) => {
    const res = await PlanningService.regenerateStudySchedule(payload);
    return res.data;
  },
);

export const postponeChapterAction = createAsyncThunk(
  "planning/postponeChapter",
  async (payload: PostponeChapterInput, thunkAPI) => {
    const res = await PlanningService.postponeChapter(payload);
    return res.data;
  },
);

export const studyScheduleAction = createAsyncThunk(
  "planning/studySchedule",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.studySchedule(payload);
    return res.data;
  },
);

export const reviewScheduleAction = createAsyncThunk(
  "planning/reviewSchedule",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.reviewSchedule(payload);
    return res.data;
  },
);

export const sampleChapterAction = createAsyncThunk(
  "planning/sampleChapter",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.chapterSpeedConfiguration(payload);
    return res.data;
  },
);

export const reportableElementsAction = createAsyncThunk(
  "planning/reportableElements",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.reportableElements(payload);
    return res.data;
  },
);

export const resourcesProgressReportsAction = createAsyncThunk(
  "planning/resourcesProgressReports",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.resourcesProgressReports(payload);
    return res.data;
  },
);

export const chaptersPlannedTimeSumReportsAction = createAsyncThunk(
  "planning/chaptersPlannedTimeSumReports",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.chaptersPlannedTimeSumReports(payload);
    return res.data;
  },
);

export const periodicElementReportsAction = createAsyncThunk(
  "planning/periodicElementReports",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.periodicElementReports(payload);
    return res.data;
  },
);

export const microscopicPlannedResourcesAction = createAsyncThunk(
  "planning/microscopicPlannedResources",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.microscopicPlannedResources(payload);
    return res.data;
  },
);

export const planResourcesAction = createAsyncThunk(
  "planning/planResources",
  async (payload: PlanResourcesInput, thunkAPI) => {
    const res = await PlanningService.planResources(payload);
    return res.data;
  },
);

export const planResourceAction = createAsyncThunk(
  "planning/planResource",
  async (payload: PlanResourceInput, thunkAPI) => {
    const res = await PlanningService.planResource(payload);
    return res.data;
  },
);

export const unplanResourceAction = createAsyncThunk(
  "planning/unplanResource",
  async (payload: UnplanResourceInput, thunkAPI) => {
    const res = await PlanningService.unplanResource(payload);
    return res.data;
  },
);

export const updatePlannedResourceAction = createAsyncThunk(
  "planning/updatePlannedResource",
  async (payload: UpdatePlannedResourceInput, thunkAPI) => {
    const res = await PlanningService.updatePlannedResource(payload);
    return res.data;
  },
);

export const changeProgressType = createAsyncThunk(
  "planning/changeProgressType",
  async (payload: ChangeProgressTypeInput, thunkAPI) => {
    const res = await PlanningService.changeProgressType(payload);
    return res.data;
  },
);

export const planChaptersAction = createAsyncThunk(
  "planning/planChapters",
  async (payload: PlanChaptersInput, thunkAPI) => {
    const res = await PlanningService.planChapters(payload);
    return res.data;
  },
);

export const resourcePackagesAction = createAsyncThunk(
  "planning/resourcePackages",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.resourcePackages(payload);    
    return res.data;
  },
);

export const resourcePackageResourcesAction = createAsyncThunk(
  "planning/resourcePackageResources",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.resourcePackageResources(payload);
    return res.data;
  },
);

export const applicantResourcesQueryAction = createAsyncThunk<ResourceQueryOutput, ResourceQueryInput>(
  "planning/applicantResourcesQuery",
  async (payload, thunkAPI) => {
    const res = await infiniteScrollThunk<ResourceQueryInput, InternalExternalResourcePortable, ResourceQueryOutput>(
      PlanningService.applicantResourcesQuery, payload);
    return res.data;
  },
);

export const chaptersQueryAction = createAsyncThunk<ChaptersQueryOutput, ChaptersQueryInput>(
  "planning/chaptersQuery",
  async (payload, thunkAPI) => {
    const res = await paginationThunk<ChaptersQueryInput, ChapterPortable, ChaptersQueryOutput>(PlanningService.chaptersQuery, payload);
    return res.data;
  },
);

export const plannedChaptersQueryAction = createAsyncThunk<PlannedChapterQueryOutput, PlannedChapterQueryInput> (
  "planning/plannedChaptersQuery",
  async (payload, thunkAPI) => {
    const res = await paginationThunk<PlannedChapterQueryInput, PlannedChapterWithChapterWithFocusedPortable, PlannedChapterQueryOutput>(PlanningService.plannedChaptersQuery, payload);
    return res.data;
  },
);

export const plannedResourcesQueryAction = createAsyncThunk<PlannedResourcesQueryOutput, PlannedResourcesQueryInput>(
  "planning/plannedResourcesQuery",
  async (payload, thunkAPI) => {
    const res = await infiniteScrollThunk<PlannedResourcesQueryInput, PlannedResourcePlusResourceRequestPortable, PlannedResourcesQueryOutput>(
      PlanningService.plannedResourcesQuery, payload);
    return res.data;
  },
);

export const plannedResourceDetailsAction = createAsyncThunk(
  "planning/plannedResourceDetails",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.plannedResourceDetails(payload);
    return res.data;
  },
);

export const changeChapterStateAction = createAsyncThunk(
  "planning/changeChapterState",
  async (payload: ChangeChapterStateInput, thunkAPI) => {
    const res = await PlanningService.changeChapterState(payload);
    return res.data;
  },
);

export const configMaxRoundAction = createAsyncThunk(
  "planning/configMaxRound",
  async (payload: ConfigMaxRoundInput, thunkAPI) => {
    const res = await PlanningService.configMaxRound(payload);
    return res.data;
  },
);

export const studyAnalyseAction = createAsyncThunk(
  "planning/studyAnalyse",
  async (payload: string, thunkAPI) => {
    const res = await PlanningService.studyAnalyse(payload);
    return res.data;
  },
);

interface WithLoadingState<T> {
  success: boolean;
  requesting: boolean;
  error: boolean;
  data?: T;
}

export interface PlanningState {
  generateTimetable?: WithLoadingState<GenerateTimetableOutput>;
  persistBasicStudyPeriod?: WithLoadingState<PersistTimetableItemOutput>;
  persistTimetableItem?: WithLoadingState<PersistTimetableItemOutput>;
  removeTimetableItem?: WithLoadingState<RemoveTimetableItemOutput>;
  fixizeEnrollmentStudyPeriodsStartType?: WithLoadingState<FixizeEnrollmentStudyPeriodsStartTypeOutput>;
  orderizeEnrollmentStudyPeriodsStartType?: WithLoadingState<OrderizeEnrollmentStudyPeriodsStartTypeOutput>;
  removeAllBasicStudyPeriods?: WithLoadingState<RemoveAllTimetableItemsOutput>;
  resetEnrollment?: WithLoadingState<ResetEnrollmentOutput>;
  timetableItems?: WithLoadingState<TimetableItemsQueryOutput>;
  enrollmentDetails?: WithLoadingState<EnrollmentWithExamWithFieldWithBranchPortable>;
  reportProgresses?: WithLoadingState<ReportProgressesOutput>;
  configSpeeds?: WithLoadingState<ConfigureChapterSpeedOutput>;
  configSpeed?: WithLoadingState<ConfigureChapterSpeedOutput>;
  regenerateStudySchedule?: WithLoadingState<RegenerateStudyScheduleOutput>;
  updateEnrollment?: WithLoadingState<UpdateEnrollmentOutput>;
  postponeChapter?: WithLoadingState<PostponeChapterOutput>;
  studySchedule?: WithLoadingState<StudyScheduleOutput>;
  reviewSchedule?: WithLoadingState<ScheduledChapterReviewsOutput>;
  sampleChapter?: WithLoadingState<ChapterSpeedConfigurationOutput>;
  reportableElements?: WithLoadingState<ReportableElementsOutput>;
  resourcesProgressReports?: WithLoadingState<ResourcesProgressReportsOutput>;
  chaptersPlannedTimeSumReports?: WithLoadingState<ChaptersPlannedTimeSumReportsOutput>;
  periodicElementReports?: WithLoadingState<PeriodicElementReportsOutput>;
  microscopicPlannedResources?: WithLoadingState<MicroscopicPlannedResourcesOutput>;
  updateApplicantProfile?: WithLoadingState<UpdateApplicantProfileOutput>;
  loadApplicantProfile?: WithLoadingState<LoadApplicantProfileOutput>;
  planResources?: WithLoadingState<PlanResourcesOutput>;
  planResource?: WithLoadingState<PlanResourceOutput>;
  unplanResource?: WithLoadingState<UnplanResourceOutput>;
  updatePlannedResource?: WithLoadingState<UpdatePlannedResourceOutput>;
  changePlannedChapter?: WithLoadingState<ChangeProgressTypeOutput>;
  planChapter?: WithLoadingState<PlanChapterOutput>;
  unplanChapter?: WithLoadingState<UnplanChapterOutput>;
  planChapters?: WithLoadingState<PlanChaptersOutput>;
  changeChapterState?: WithLoadingState<ChangeChapterStateOutput>;
  resourcePackages?: WithLoadingState<ResourcePackagePortable[]>;
  resourcePackageResources?: WithLoadingState<
    ResourcePackageResourcesOutput & { checked?: boolean }
  >;
  applicantResourcesQuery?: WithLoadingState<ResourceQueryOutput>;
  chaptersQuery?: WithLoadingState<ChaptersQueryOutput>;
  plannedChaptersQuery?: WithLoadingState<PlannedChapterQueryOutput>;
  plannedResourcesQuery: WithLoadingState<PlannedResourcesQueryOutput>;
  plannedResourceDetails?: WithLoadingState<PlannedResourceDetailsOutput>;
  configMaxRound?: WithLoadingState<ConfigureChapterSpeedOutput>;
  studyAnalyse?: WithLoadingState<StudyAnalyseOutput>;
  schedulesRegenerateNeeded?: boolean;
}

const initialState: PlanningState = {
  generateTimetable: { success: false, error: false, requesting: false },
  persistBasicStudyPeriod: { success: false, error: false, requesting: false },
  persistTimetableItem: { success: false, error: false, requesting: false },
  removeTimetableItem: { success: false, error: false, requesting: false },
  fixizeEnrollmentStudyPeriodsStartType: {
    success: false,
    error: false,
    requesting: false,
  },
  orderizeEnrollmentStudyPeriodsStartType: {
    success: false,
    error: false,
    requesting: false,
  },
  removeAllBasicStudyPeriods: {
    success: false,
    error: false,
    requesting: false,
  },
  resetEnrollment: { success: false, error: false, requesting: false },
  timetableItems: { success: false, error: false, requesting: false },
  enrollmentDetails: { success: false, error: false, requesting: false },
  reportProgresses: { success: false, error: false, requesting: false },
  configSpeeds: { success: false, error: false, requesting: false },
  configSpeed: { success: false, error: false, requesting: false },
  regenerateStudySchedule: { success: false, error: false, requesting: false },
  updateEnrollment: { success: false, error: false, requesting: false },
  postponeChapter: { success: false, error: false, requesting: false },
  studySchedule: { success: false, error: false, requesting: false },
  reviewSchedule: { success: false, error: false, requesting: false },
  sampleChapter: { success: false, error: false, requesting: false },
  reportableElements: { success: false, error: false, requesting: false },
  resourcesProgressReports: { success: false, error: false, requesting: false },
  chaptersPlannedTimeSumReports: {
    success: false,
    error: false,
    requesting: false,
  },
  periodicElementReports: { success: false, error: false, requesting: false },
  microscopicPlannedResources: {
    success: false,
    error: false,
    requesting: false,
  },
  updateApplicantProfile: { success: false, error: false, requesting: false },
  loadApplicantProfile: { success: false, error: false, requesting: false },
  planResources: { success: false, error: false, requesting: false },
  planResource: { success: false, error: false, requesting: false },
  unplanResource: { success: false, error: false, requesting: false },
  updatePlannedResource: { success: false, error: false, requesting: false },
  changePlannedChapter: { success: false, error: false, requesting: false },
  planChapter: { success: false, error: false, requesting: false },
  unplanChapter: { success: false, error: false, requesting: false },
  planChapters: { success: false, error: false, requesting: false },
  changeChapterState: { success: false, error: false, requesting: false },
  resourcePackages: { success: false, error: false, requesting: false },
  resourcePackageResources: { success: false, error: false, requesting: false },
  applicantResourcesQuery: { success: false, error: false, requesting: false },
  chaptersQuery: { success: false, error: false, requesting: false },
  plannedChaptersQuery: { success: false, error: false, requesting: false },
  plannedResourcesQuery: { success: false, error: false, requesting: false },
  plannedResourceDetails: { success: false, error: false, requesting: false },
  configMaxRound: { success: false, error: false, requesting: false },
  studyAnalyse: { success: false, error: false, requesting: false },
};

export const planningSlice = createSlice({
  name: "planning",
  initialState,
  reducers: {
    resetGenerateTimetableAction: (state) => {
      state.generateTimetable = initialState.generateTimetable;
    },
    resetPersistBasicStudyPeriodAction: (state) => {
      state.persistBasicStudyPeriod = initialState.persistBasicStudyPeriod;
    },
    resetRemoveTimetableItemAction: (state) => {
      state.removeTimetableItem = initialState.removeTimetableItem;
    },
    resetFixizeEnrollmentStudyPeriodsStartTypeAction: (state) => {
      state.fixizeEnrollmentStudyPeriodsStartType =
        initialState.fixizeEnrollmentStudyPeriodsStartType;
    },
    resetOrderizeEnrollmentStudyPeriodsStartTypeAction: (state) => {
      state.orderizeEnrollmentStudyPeriodsStartType =
        initialState.orderizeEnrollmentStudyPeriodsStartType;
    },
    resetRemoveAllBasicStudyPeriodsAction: (state) => {
      state.removeAllBasicStudyPeriods =
        initialState.removeAllBasicStudyPeriods;
    },
    updateReviewListAction: (
      state,
      action: PayloadAction<
        Partial<ScheduledChapterReviewWithPlannedChapterPortable>
      >,
    ) => {
      state.reviewSchedule?.data?.Items?.map((item) =>
        item?.ScheduledChapterReviewId ===
        action.payload.ScheduledChapterReviewId
          ? action.payload
          : item,
      );
    },
    resetRegenerateStudyScheduleAction: (state) => {
      state.regenerateStudySchedule = initialState.regenerateStudySchedule;
    },
    resetChangePlannedChapterAction: (state) => {
      state.changePlannedChapter = initialState.changeChapterState;
    },
    updatePlannedChapterStateInStudyScheduleAction: (
      state,
      action: PayloadAction<{
        ScheduledElementId: number;
        newChapterState: PlannedChapterStates | undefined;
      }>,
    ) => {
      state.studySchedule?.data?.Items?.forEach((item) => {
        item.Elements?.forEach((element) => {
          if (
            element.ScheduledElementId === action.payload.ScheduledElementId
          ) {
            switch (action.payload.newChapterState) {
              case PlannedChapterStates.Postponed: {
                element.Postponed = true;
                break;
              }
              case PlannedChapterStates.Enabled: {
                element.Postponed = false;
                break;
              }
            }
          }
        });
      });
    },
    setStudyScheduleItemsAction: (
      state,
      action: PayloadAction<StudyScheduleOutput["Items"]>,
    ) => {
      state.studySchedule?.data?.Items &&
        (state.studySchedule.data.Items = action.payload);
    },
    updateReportableChaptersAction: (
      state,
      action: PayloadAction<PlannedElementPortable>,
    ) => {
      if (state.reportableElements?.data) {
        state.reportableElements.data.Elements =
          state.reportableElements.data.Elements?.map((item) => {
            if (!item.Items) return item;
            let index = item.Items.findIndex(
              (i) => i.RelatedElementId === action.payload.RelatedElementId,
            );
            if (index >= 0) {
              item.Items[index] = action.payload;
            }
            return item;
          });
      }
    },
    updatemicroscopicPlannedResourcesItemAction: (
      state,
      action: PayloadAction<PlannedResourceWithResourcePortable>,
    ) => {
      if (state.microscopicPlannedResources?.data?.Items) {
        state.microscopicPlannedResources.data.Items =
          state.microscopicPlannedResources.data.Items.map((item) =>
            item.PlannedResourceId === action.payload.PlannedResourceId
              ? action.payload
              : item,
          );
      }
    },
    resetPlanChaptersAction: (state) => {
      state.planChapters = initialState.planChapters;
    },
    deletePlannedResourcesQueryItemAction: (
      state,
      action: PayloadAction<{ PlannedResourceId: number }>,
    ) => {
      state.plannedResourcesQuery?.data?.Items &&
        (state.plannedResourcesQuery.data.Items =
          state.plannedResourcesQuery?.data?.Items?.filter(
            (item) =>
              item?.PlannedResourceId != action.payload.PlannedResourceId,
          ));
    },
    updatePlannedResourcesQueryItemAction: (
      state,
      action: PayloadAction<{
        item: Exclude<
          PlannedResourceWithResourceWithFocusedChaptersPortable,
          null | undefined
        >;
      }>,
    ) => {
      if (state.plannedResourcesQuery?.data?.Items) {
        state.plannedResourcesQuery.data.Items =
          state.plannedResourcesQuery.data.Items.map((item) =>
            item.PlannedResourceId === action.payload.item.PlannedResourceId
              ? action.payload.item
              : item,
          );
      }
    },
    addPlannedResourcesQueryItemsAction: (
      state,
      action: PayloadAction<{ items: PlannedResourcesQueryOutput["Items"] }>,
    ) => {
      if (!action.payload.items) return;
      state.plannedResourcesQuery?.data?.Items?.push(...action.payload.items);
    },
    resetUnplanResourceAction: (state) => {
      state.unplanResource = initialState.unplanResource;
    },
    resetUpdatePlannedResourceAction: (state) => {
      state.updatePlannedResource = initialState.updatePlannedResource;
    },
    resetPlanResourcesAction: (state) => {
      state.planResources = initialState.planResources;
    },
    updateBasicStudyPeriodsQueryAction: (
      state,
      action: PayloadAction<TimetableItemPortable>,
    ) => {
      if (state.timetableItems?.data?.Items) {
        const plannedResource = state.plannedResourcesQuery?.data?.Items?.find(
          (i) => i.ResourceId === action.payload.ResourceId,
        );
        const payload = action.payload;

        let payloadPosition = payload.Position;
        let oldPosition = state.timetableItems.data.Items.find(
          (i) => i.BasicStudyPeriodId === payload.BasicStudyPeriodId,
        )?.Position;

        if (payloadPosition && oldPosition && payloadPosition > oldPosition) {
          state.timetableItems.data.Items = state.timetableItems.data.Items.map(
            (item) =>
              item.Position &&
              //@ts-ignore
              item.Position <= payloadPosition &&
              //@ts-ignore
              item.Position > oldPosition
                ? { ...item, Position: item.Position - 1 }
                : item,
          );
        } else if (
          payloadPosition &&
          oldPosition &&
          payloadPosition < oldPosition
        ) {
          state.timetableItems.data.Items = state.timetableItems.data.Items.map(
            (item) =>
              item.Position &&
              //@ts-ignore
              item.Position >= payloadPosition &&
              //@ts-ignore
              item.Position < oldPosition
                ? { ...item, Position: item.Position + 1 }
                : item,
          );
        }

        state.timetableItems.data.Items = state.timetableItems.data.Items.map(
          (i) =>
            i.BasicStudyPeriodId === payload.BasicStudyPeriodId
              ? { ...payload, Resource: plannedResource?.Resource }
              : i,
        );
      }
    },
    resetPersistTimetableItemAction: (state) => {
      state.persistTimetableItem = initialState.persistTimetableItem;
    },
    deleteBasicStudyPeriodsQueryItemAction: (
      state,
      action: PayloadAction<number>,
    ) => {
      if (state.timetableItems?.data?.Items) {
        state.timetableItems.data.Items =
          state.timetableItems?.data?.Items?.filter(
            (item) => item.BasicStudyPeriodId !== action.payload,
          );
      }
    },
    addBasicStudyPeriodsQueryItemAction: (
      state,
      action: PayloadAction<TimetableItemPortable>,
    ) => {
      if (state.timetableItems?.data?.Items) {
        const resource = state.plannedResourcesQuery?.data?.Items?.find(
          (i) => i.ResourceId === action.payload.ResourceId,
        );
        const payload =
          action.payload as TimetableItemWithColorWithResourcePortable;

        let payloadPosition = payload.Position;
        if (payloadPosition) {
          state.timetableItems.data.Items = state.timetableItems.data.Items.map(
            (item) =>
              //@ts-ignore
              item.Position && item.Position >= payloadPosition
                ? { ...item, Position: item.Position + 1 }
                : item,
          );
        }

        state.timetableItems.data.Items.push({
          ...payload,
          Resource: resource?.Resource,
        });
      }
    },
    resetBasicStudyPeriodsQueryAction: (state) => {
      state.timetableItems = initialState.timetableItems;
    },
    resetApplicantResourcesQueryAction: (state) => {
      state.applicantResourcesQuery = initialState.applicantResourcesQuery;
    },
    addPlannedResourcesQueryAction: (
      state,
      action: PayloadAction<
        PlannedResourceWithResourceWithFocusedChaptersPortable[]
      >,
    ) => {
      if (state.plannedResourcesQuery?.data?.Items) {
        state.plannedResourcesQuery.data.Items.push(...action.payload);
      }
    },
    setPlannedResourcesQueryItemsAction: (
      state,
      action: PayloadAction<PlannedResourcePlusResourceRequestPortable[]>,
    ) => {
      if (!state.plannedResourcesQuery?.data?.Items) {
        state.plannedResourcesQuery = {
          ...initialState.plannedResourcesQuery,
          data: {
            Items: action.payload,
          },
        };
      } else {
        state.plannedResourcesQuery.data.Items = action.payload;
      }
    },
    resetPlannedResourcesQueryAction: (state) => {
      state.plannedResourcesQuery = initialState.plannedResourcesQuery;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        fixizeEnrollmentStudyPeriodsStartTypeAction.fulfilled,
        (state, action) => {
          if (state.enrollmentDetails?.data) {
            state.enrollmentDetails.data.StudyPeriodsStartType =
              StudyPeriodStartTypes.Fixed;
          }
        },
      )
      .addCase(
        orderizeEnrollmentStudyPeriodsStartTypeAction.fulfilled,
        (state, action) => {
          if (state.enrollmentDetails?.data) {
            state.enrollmentDetails.data.StudyPeriodsStartType =
              StudyPeriodStartTypes.Ordinary;
          }
        },
      )
      .addMatcher(isAsyncThunkAction, (state, action) => {
        const { type } = action;
        const [, name] = type.split("/");
        const partialState = state[name as keyof typeof state] as
          | WithLoadingState<any>
          | undefined;

        if (partialState) {
          partialState.requesting = isPending(action);
          partialState.error = isRejected(action);

          if (isFulfilled(action)) {
            partialState.success = true;
            partialState.data = action.payload;

            if (
              typeof action.payload === "object" &&
              "SchedulesRegenerateNeeded" in (action.payload as any)
            ) {
              state.schedulesRegenerateNeeded = (
                action.payload as any
              )?.SchedulesRegenerateNeeded;
            }
          }
        }
      });
  },
});

export const {
  resetChangePlannedChapterAction,
  resetFixizeEnrollmentStudyPeriodsStartTypeAction,
  resetGenerateTimetableAction,
  resetOrderizeEnrollmentStudyPeriodsStartTypeAction,
  resetPersistBasicStudyPeriodAction,
  resetRegenerateStudyScheduleAction,
  resetRemoveAllBasicStudyPeriodsAction,
  resetRemoveTimetableItemAction,
  setStudyScheduleItemsAction,
  updatemicroscopicPlannedResourcesItemAction,
  updatePlannedChapterStateInStudyScheduleAction,
  updateReportableChaptersAction,
  updateReviewListAction,
  resetPlanChaptersAction,
  deletePlannedResourcesQueryItemAction,
  resetUnplanResourceAction,
  updatePlannedResourcesQueryItemAction,
  resetUpdatePlannedResourceAction,
  resetPlanResourcesAction,
  addPlannedResourcesQueryItemsAction,
  updateBasicStudyPeriodsQueryAction,
  resetPersistTimetableItemAction,
  deleteBasicStudyPeriodsQueryItemAction,
  resetBasicStudyPeriodsQueryAction,
  resetApplicantResourcesQueryAction,
  addPlannedResourcesQueryAction,
  resetPlannedResourcesQueryAction,
  setPlannedResourcesQueryItemsAction,
  addBasicStudyPeriodsQueryItemAction,
} = planningSlice.actions;

export default planningSlice.reducer;
